import { FolderSwapIcon } from '@tableau/icons/FolderSwapIcon';
import { UploadBaseIcon } from '@tableau/icons/UploadBaseIcon';
import {
  FlyoutListMenuWidget, HorizontalOriginOption, IconLibraryIcon, MenuButtonWidget, MenuItemInfo, VerticalOriginOption
} from '@tableau/widgets';
import React from 'react';

import { ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { Messages } from '~src/codegen/Localize';
import { ExplorerStyles } from '~src/spacesPlatform/components/Explorer/ExplorerStyles';

import { RelayPlanDialogOpts } from '../components/RelayPlanDialog';
import { UploadBundleDialogOpts } from '../components/UploadBundleDialog';

const NewMenuValue = {
  RelayPlan: 'relayPlan',
  ImportPackage: 'importPackage',
};

// Same icon sizing as the platform New menu's items (CreateContentButton).
function menuIcon(icon: (props: any) => React.ReactSVGElement | null): IconLibraryIcon {
  return function(props) { return icon({ size: ExplorerStyles.buttonIconSize, color: props.color }); };
}

/**
 * The Content Relays "New" menu, styled like the platform CreateContentButton. Today it offers
 * "Relay plan" (start an empty plan; content is added from Explore). "Import package" opens the
 * destination-side bundle upload (W-23846349).
 */
export function NewRelayPlanButton(): JSX.Element {
  const [open, setOpen] = React.useState(false);
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const menuItems: MenuItemInfo[] = [
    {
      displayValue: Messages.relayPlanNewMenuPlan(),
      value: NewMenuValue.RelayPlan,
      icon: menuIcon(FolderSwapIcon),
    },
    {
      displayValue: Messages.relayPlanNewMenuImport(),
      value: NewMenuValue.ImportPackage,
      icon: menuIcon(UploadBaseIcon),
    },
  ];

  const onSelect = function(value: string): void {
    setOpen(false);
    if (value === NewMenuValue.RelayPlan) {
      ReactModalService.openCustom(RelayPlanDialogOpts([]));
    } else if (value === NewMenuValue.ImportPackage) {
      ReactModalService.openCustom(UploadBundleDialogOpts());
    }
  };

  return (
    <div>
      <MenuButtonWidget
        aria-expanded={open}
        aria-haspopup={'menu'}
        aria-controls={'content-relays-new-menu'}
        children={Messages.createContent_new()}
        onClick={function() { setOpen(!open); }}
        kind={'outline'}
        ref={buttonRef}
        testId={'content-relays-new'}
      />
      {open && (
        <FlyoutListMenuWidget
          allowAutoPosition
          anchorEl={buttonRef.current}
          anchorOrigin={{ vertical: VerticalOriginOption.bottom, horizontal: HorizontalOriginOption.left }}
          className={ExplorerStyles.CreateContentMenuItemsStyleName}
          menuItemInfos={menuItems}
          onSelect={onSelect}
          requestCloseAll={function() { setOpen(false); }}
          id={'content-relays-new-menu'}
          testId={'content-relays-new-menu'}
          toggleEl={buttonRef.current}
          menuStyle={{ minWidth: '150px', whiteSpace: 'nowrap' }}
        />
      )}
    </div>
  );
}
